import type { FunctionComponent } from 'react'

const IconSize = {
  xsmall: { width: 16, height: 16 },
  small: { width: 24, height: 24 },
}

interface UndoIconProps {
  color: string
  size?: 'xsmall' | 'small'
  isFlipped?: boolean
}

export const UndoIcon: FunctionComponent<UndoIconProps> = ({
  color,
  isFlipped,
  size = 'xsmall',
}) => {
  const flip = isFlipped ? { transform: 'scale(-1, 1)' } : {}
  return (
    <svg
      style={{ ...flip }}
      width={IconSize[size].width}
      height={IconSize[size].height}
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.961 15.6653C10.7754 15.6653 10.5954 15.5865 10.4716 15.4346C10.2466 15.1646 10.286 14.7653 10.556 14.5403C11.6079 13.674 12.3054 12.3184 12.4235 10.9178C12.5529 9.44401 12.0466 7.88589 11.0622 6.73839C10.0385 5.52901 8.4691 4.73589 6.85473 4.62339C6.52285 4.60089 6.22473 4.31964 6.22473 3.98776V2.28339L1.94411 5.63026L6.22473 8.97714V7.27276C6.22473 6.95214 6.46098 6.68214 6.78161 6.64276C6.79848 6.64276 6.82098 6.64276 6.84348 6.64276C8.01348 6.48526 9.2341 6.82276 10.1904 7.56526C11.2141 8.35276 11.8947 9.56776 12.041 10.8953C12.0804 11.244 11.8329 11.559 11.4841 11.5984C11.1297 11.6378 10.8204 11.3903 10.781 11.0415C10.6685 10.0571 10.1679 9.15151 9.41411 8.57213C8.85161 8.13339 8.1766 7.89152 7.49598 7.87464V10.2821C7.49598 10.524 7.35536 10.7434 7.14161 10.8503C6.92223 10.9571 6.66348 10.929 6.47223 10.7771L0.526604 6.12527C0.374729 6.00714 0.284729 5.82152 0.284729 5.62464C0.284729 5.42777 0.374729 5.24777 0.526604 5.12402L6.47223 0.472138C6.66348 0.320263 6.92223 0.292136 7.14161 0.399011C7.36098 0.505886 7.49598 0.725266 7.49598 0.967141V3.40276C9.26223 3.67276 10.916 4.57838 12.0297 5.90026C13.2447 7.31776 13.8522 9.17964 13.6891 11.0078C13.5485 12.7628 12.6991 14.4053 11.366 15.5021C11.2479 15.5978 11.1072 15.6484 10.961 15.6484V15.6653Z"
        fill={color}
      />
    </svg>
  )
}
